module.exports = __webpack_public_path__ + "img/ticket-email.aef700c4.png";